export default () => ({
  issue: null,
  issues: []
})



// WEBPACK FOOTER //
// ./src/store/modules/issues/state.js